// extracted by mini-css-extract-plugin
export default {"wrapper":"hE-z","viewport":"iE-z","container":"jE-z","slide":"kE-z"};